export default __webpack_public_path__ + "locales/it/DeleteProfileEverDialog.json?hash=73d96b53be2f69ccd64568019d4ccfd4";